"use client";

import { RedirectPage } from "@/app/redirect";

const Home = () => {
  return <RedirectPage />;
};

export default Home;
